import styled, { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

const PALETTE_WIDTH = 124;

export const StyledWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    height: ${utils.rem(theme.Components.Panel.Height)};
  `
);

export const StyledContent = styled.a(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${utils.rem(theme.Spacing.Size.XSmall)};
    padding: 0 ${utils.rem(theme.Spacing.Size.XSmall)};
  `
);

export const StyledPaletteWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    bottom: ${utils.rem(theme.Spacing.Size.MediumSmall)};
    left: ${utils.rem(theme.Spacing.Size.MediumSmall)};
    width: ${utils.rem(PALETTE_WIDTH)};
    height: ${utils.rem(theme.Components.Panel.Height / 2)};
    z-index: 1;
  `
);
